const utils = {
    getExtension: fname => fname.slice((fname.lastIndexOf(".") - 1 >>> 0) + 2),
    bytesToSize: (bytes, decimals) => {
        if(bytes == 0) return '0 Bytes';
        var k = 1000,
            dm = decimals + 1 || 3,
            sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];    }
};

module.exports = utils;



/** WEBPACK FOOTER **
 ** ../src/common/utils.js
 **/